import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		HOME_FULLPAGE: null,		// home 全屏滚动类
		NAVBTN_ACTIVED: false,
		CLUE_STAGE: 6,

		GALLERY_MASK_ACTIVE: false,		// 图片遮罩状态
		GALLERY_IMG: '',
		GALLERY_TAG: []
	},
	mutations: {
		INIT_HOME_FULLPAGE: (state, params) => {
			state.HOME_FULLPAGE = params
		},
		SET_NAVBTN_ACTIVED: (state, params) => {
			state.NAVBTN_ACTIVED = params
		},
		SET_GALLERY_MASK_ACTIVE: (state, params) => {	// 设置图片遮罩状态
			state.GALLERY_MASK_ACTIVE = params.show
			state.GALLERY_IMG = params.img
			state.GALLERY_TAG = params.tag
		},
	},
	actions: {
		
	},
	getters: {
		NAV_ACTIVE_INDEX: state => {
			if(state.HOME_FULLPAGE) {
				return state.HOME_FULLPAGE.activeIndex
			} else {
				return -1
			}
		}
	}
})
